import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { familyMembersCollection } from 'app/src/msw/membership/initialSeed/familyMembers'
import type { UserFamilyMember } from 'app/src/services/welfareportal'
import { http, HttpResponse } from 'msw'

export const getFamilyMembers = http.get<object, object, UserFamilyMember[]>(
  apiBaseUrl + '/memberships/:membershipid/familyMembers',
  () => {
    const familyMembers: UserFamilyMember[] | undefined = familyMembersCollection.findMany()

    console.log('GET FAMILY MEMBERS', familyMembers)

    return HttpResponse.json(familyMembers)
  },
)
